/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `classification` - classification
 * * `regression` - regression
 * @export
 */
export const ModelClassEnum = {
  classification: 'classification',
  regression: 'regression',
} as const;
export type ModelClassEnum = (typeof ModelClassEnum)[keyof typeof ModelClassEnum];

export function instanceOfModelClassEnum(value: any): boolean {
  for (const key in ModelClassEnum) {
    if (Object.prototype.hasOwnProperty.call(ModelClassEnum, key)) {
      if ((ModelClassEnum as Record<string, ModelClassEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ModelClassEnumFromJSON(json: any): ModelClassEnum {
  return ModelClassEnumFromJSONTyped(json, false);
}

export function ModelClassEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelClassEnum {
  return json as ModelClassEnum;
}

export function ModelClassEnumToJSON(value?: ModelClassEnum | null): any {
  return value as any;
}
